import WarningModal from '~/components/WarningModal'
import { useAppSelector } from '~/redux/hooks'

import { selectCurriculumChangeLoading } from '../slice/curriculum.slice'
import { useCurriculumChange } from '../hooks/useCurriculumChange'

export default function CurriculumChangeWarningModal({ isOnboarding }: { isOnboarding?: boolean }): React.ReactElement {
  const isChangeLoading = useAppSelector(selectCurriculumChangeLoading)
  const { cancelOnClick, handleConfirmSelect: changeCurriculumOnCLick } = useCurriculumChange(isOnboarding)

  return (
    <WarningModal
      cancelOnClick={cancelOnClick}
      continueOnClick={changeCurriculumOnCLick}
      i18nKey="curriculum:curriculumChangeWarning"
      i18nNamespace="curriculum"
      isChangeLoading={isChangeLoading}
    />
  )
}
